
import React from 'react'
import {connect} from "react-redux"

import SelectTherapyAreas from './SelectTherapyAreas.jsx';


import './styles/AdminTherapyArea.scss';
import deleteImage from '../../images/icons/close_black.svg';
import { adminSaveTherapyCategory, adminSaveTherapyArea, adminToggleCategoryTherapyArea } from "../../actions/admin"

@connect(store => {
  return {
    therapy_areas: store.therapy_areas,
    practice_types: store.practice_types
  };
})
class AdminTherapyCategory extends React.Component {
  constructor(props) {
    super(props);
    this.edit = this.edit.bind(this);
    this.save = this.save.bind(this);
    this.editOptions = this.editOptions.bind(this);
    this.displayOptions = this.displayOptions.bind(this);
    this.handleItemChange = this.handleItemChange.bind(this);
    this.handleAreaClick = this.handleAreaClick.bind(this);
    this.handleCategoryTypeChange = this.handleCategoryTypeChange.bind(this);

    this.state = {
      editing: false,
      item: this.props.category
    };
  }

  save() {
    this.props.dispatch(adminSaveTherapyCategory(this.state.item));
    // save therapy areas associated to this Category
    Object.values(this.props.therapy_areas).forEach(area => {
      this.props.dispatch(adminSaveTherapyArea(area));
    });
    this.edit();
  }

  handleItemChange(e, field) {
    let item = this.state.item;
    item[field] = e.target.value;
    this.setState({ item: item });
  }

  edit() {
    this.setState({
      editing: !this.state.editing
    });
  }

  handleAreaClick(area) {
    this.props.dispatch(
      adminToggleCategoryTherapyArea(area, this.props.category._id)
    );
  }

  handleCategoryTypeChange(event, type) {
    let itemObj = this.state.item;
    itemObj[type] = event.target.value;
    this.setState({ item: itemObj });
  }

  editOptions() {
    if (this.state.editing) {
      return (
        <div>
          <button
            className="md-button md-accent md-raised link"
            onClick={this.save}
          >
            Save
          </button>
          &nbsp;{" "}
          <a className="link" onClick={this.edit}>
            Cancel
          </a>
        </div>
      );
    } else {
      return (
        <div>
          <a className="link" onClick={this.edit}>
            Edit
          </a>
        </div>
      );
    }
  }

  displayOptions() {
    if (this.state.editing) {
      return (
        <div>
          <h6 className="md-subhead">
            <input
              className="md-input md-title"
              onChange={e => this.handleItemChange(e, "name")}
              value={this.state.item.name}
              type="text"
              placeholder="Therapy category title"
            />
          </h6>
          <div className="select my1">
            Profession:
            <select
              value={this.state.item.practice_type}
              onChange={e => this.handleCategoryTypeChange(e, "practice_type")}
            >
              {this.props.practice_types.map(type => (
                <option key={type.id} value={type.id}>
                  {type.practice_type}
                </option>
              ))}
            </select>
          </div>
          <textarea
            className="md-input multiple"
            value={this.state.item.description}
            placeholder="Therapy category description"
            onChange={e => this.handleItemChange(e, "description")}
          />
          <div className="row">
            <div className="fill">
              <input
                className="md-input md-title"
                onChange={e => this.handleItemChange(e, "image")}
                value={this.state.item.image}
                type="text"
                placeholder="Therapy category image"
              />
            </div>
            <div>
              {this.state.item.image && (
                <img
                  height="32"
                  alt={this.state.item.name}
                  className="category-icon"
                  src={require("../../images/icons/categories/" +
                    this.state.item.image)}
                />
              )}
            </div>
          </div>

          <p>Areas</p>
          <div>
            <SelectTherapyAreas
              checkedCond={area => {
                return area.categories.indexOf(this.props.category._id) !== -1;
              }}
              therapy_areas={Object.values(this.props.therapy_areas)}
              click={this.handleAreaClick}
              itemId={this.state.item._id}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <h6 className="md-subhead row">
            <div>
              {this.state.item.image && (
                <img
                  className="category-icon"
                  alt={this.state.item.name}
                  src={require("../../images/icons/categories/" +
                    this.state.item.image)}
                />
              )}
            </div>
            <div className="fill">{this.state.item.name}</div>
          </h6>
          <p>{this.state.item.description}</p>
        </div>
      );
    }
  }

  render() {
    return (
      <li
        className={
          "therapy-area  card  " + (this.state.editing ? "editing" : "")
        }
      >
        <div className="row-fill">{this.displayOptions()}</div>
        <div className="component-footer reading">
          {this.editOptions()}
          <div
            onClick={() => {
              this.props.handleDelete(this.state.item._id);
            }}
            className="delete"
          >
            <img src={deleteImage} alt="Delete" />
          </div>
        </div>
      </li>
    );
  }
}

export default AdminTherapyCategory;



// WEBPACK FOOTER //
// ./src/components/admin/AdminTherapyCategory.jsx